import type { TFunction } from "i18next";

const STATUS_CODE_KEYS: Record<string, string> = {
	EMPLOYED: "feature.status.options.employed",
	SELF_EMPLOYED: "feature.status.options.selfEmployed",
	NOT_INTERESTED: "feature.status.options.notInterested",
	UNTRACEABLE: "feature.status.options.untraceable",
	UNKNOWN: "feature.status.options.unknownPending",
	PENDING: "feature.status.options.unknownPending",
	UNKNOWN_PENDING: "feature.status.options.unknownPending",
};

const STATUS_NAME_KEYS: Record<string, string> = {
	employed: "feature.status.options.employed",
	"self employed": "feature.status.options.selfEmployed",
	"higher studies": "feature.status.options.higherStudies",
	"not interested": "feature.status.options.notInterested",
	untraceable: "feature.status.options.untraceable",
	"unknown/pending": "feature.status.options.unknownPending",
	unknown: "feature.status.options.unknownPending",
	pending: "feature.status.options.unknownPending",
};

export function getOutcomeStatusLabel(
	t: TFunction,
	apiCode?: string | null,
	fallbackName?: string | null,
): string {
	const code = apiCode?.trim().toUpperCase();
	if (code) {
		if (code.startsWith("HIGHER")) {
			return t("feature.status.options.higherStudies");
		}
		const key = STATUS_CODE_KEYS[code];
		if (key) return t(key);
	}

	const nameKey = fallbackName ? STATUS_NAME_KEYS[fallbackName.trim().toLowerCase()] : undefined;
	if (nameKey) return t(nameKey);

	return fallbackName?.trim() || t("feature.status.options.unknownPending");
}

export function getStatusEntityTitle(
	t: TFunction,
	statusType: "Employed" | "Self Employed" | "Higher Studies",
): string {
	if (statusType === "Employed") return t("feature.status.entity.employer");
	if (statusType === "Self Employed") return t("feature.status.entity.business");
	return t("feature.status.entity.institution");
}

export function getStatusModalTitle(
	t: TFunction,
	statusType: "Employed" | "Self Employed" | "Higher Studies",
): string {
	if (statusType === "Employed") return t("feature.status.options.employed");
	if (statusType === "Self Employed") return t("feature.status.options.selfEmployed");
	return t("feature.status.options.higherStudies");
}
